<div class="container main-layout">
    <div class="right-container">
        <div class="rc-heading">
            <!-- <div class="back-button" (click)="backbutton()" *ngIf="historyOn">
                &larr;
            </div> -->
            <div class="af-title">AbioChat Focus - DrQueryCoach</div>
            <div class="muteDiv">
                <button [ngClass]="mute? 'unmute' : 'mute1'" (click)="MuteAudio()">
                    <span *ngIf="!mute"><img src="../../../assets/images/JJ_Icon_Sound_On_RGB.png" alt=""></span>
                    <span *ngIf="mute"><img src="../../../assets/images/JJ_Icon_Sound_Off_RGB.png" alt=""></span> 
                </button>
            </div>

            <div class="download-tran">
                <img src="../../../assets/images/JJ_Icon_Download (1).png" (click)="displayTranscriptAsPdf()" alt="Download Transcript" title="Download Transcript">
            </div>
            </div>
        <div class="chat-window" #scrollContainer>
            <div id="loader" class="loader-container">
                <div class="loader"></div>
                <p id="loader-message">Loading FAQs for the topic {{this.loaderMessages}}. Please wait...</p>
            </div>
            <div class="frame-box" id="chat-box" #scrollMe [scrollTop]="scrollMe.scrollHeight">
                <div *ngFor="let item of conversation let i = index">
                    <div class="card-text padding" [ngClass]="item.cssClass">
                        <div class="left-side" *ngIf="item.bot_question">
                            <div class="profile-container-ai">
                                <img class="profile-img" src="../../../assets/images/Lucy.png" alt="Profile Image"
                                    title="AI chat">
                            </div>
                            <div class="bubble question-bubble">
                                <div class="time">
                                    <span class="profile-name">AI</span>at
                                    {{item.ai_timestamp  | date: 'hh:mm MMM dd'}}
                                </div>
                                <div class="typewriter-1">
                                    <p> Qns {{ i+1 }}/10: {{ item.bot_question}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="right-side" *ngIf="item.user_answer">
                            <div class="profile-container">
                                <img class="profile-img" src="../../../assets/images/JJMT_Icon_Web_Profile.png"
                                    alt="Profile Image" title="Ai chat">
                            </div>
                            <div class="bubble answer-bubble-ans">
                                <div class="time-ans">
                                    <span class="profile-name">{{givenName}}</span>
                                   at {{item.user_timestamp | date: 'hh:mm MMM dd'}}
                                </div>
                                <div class="typewriter">
                                    <p>{{ item.user_answer }}</p>
                                </div>
                                <div class="botans" *ngIf="score">
                                    <p>DrQueryCoach Answer: {{ item.bot_idle_answer }}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="left-side" *ngIf="score">
                    <div class="profile-container-ai">
                        <img class="profile-img" src="../../../assets/images/Lucy.png" alt="Profile Image"
                            title="Ai chat">
                    </div>
                    <div class="bubble question-bubble">
                        <div class="time">
                            <span class="profile-name">AI </span>at
                            {{getCurrentTime()}}
                        </div>
                        <div class="typewriter-1">
                            <span> {{ feedback }} </span>
                           <!--  <p>You have completed the quiz! <b>Your score is {{averageAge}}/10</b></p> -->
                        </div>
                    </div>
                </div>
                <div>
                    <div id="small-loader" class="small-loader"></div>
                    <div class="overlay-content"  *ngIf="showOverlay">
                        <div class="overlay-content-top " >
                            <div class="trending-topic-icon">
                                <img src="../../../assets/images/overlay-content-icon.svg" alt="Trending Topics" />
                            </div>
                            <div class="label">
                                <span class="bold-label">Hi {{givenName}}!</span>
                                <span class="light-label">It’s a great idea to test yourself. What topic would you like
                                    to take the quiz on? </span>
                                <span class="light-label">Please describe it in a few sentences. I am going to ask you
                                    10 questions on that topic.
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div class="prompt" >
                <div class="footer-input">
                    <div class="input-block">
                        <app-speech-to-text (contentClicked)="handleContent($event)"></app-speech-to-text>
                        <textarea [(ngModel)]="userAnswer" (keyup.enter)="userAnswer &&hideOverlay()" type="textarea" #textarea 
                        (input)="adjustHeight($event)"
                            (keyup.enter)="userAnswer && getNextQuestion()" class="form-control dynamic-textarea" [ngClass]="historyOn &&  !isInputEnabled? 'disabled-cs': ''"
                            placeholder="Click mic to say or type your answer here...." [disabled]="historyOn && !isInputEnabled" autofocus></textarea>
                        <img src="../../../assets/images/chat-after-icon.svg" alt="Icon" class="input-icon"
                            [class.disabled]="!userAnswer && !dataGuardeils" (keyup.enter)="hideOverlay()"
                            (click)="userAnswer && getNextQuestion()">
                    </div>
                    <div class="disclaimer-div">
                        <span class="disclaimer">*AIAdvisor can make mistakes. Consider checking the important information.​</span>
                    </div>
                </div>
            </div>

        </div>
    </div>